import SEO, { breadcrumbs } from '../components/common/SEO'
import PageHero from '../components/common/PageHero'
import { Breadcrumbs, LinkCards, BookingBand } from '../components/detail/DetailBlocks'
import { conditions, conditionsHubReviewed } from '../data/conditions'
import { SITE_URL } from '../data/site'

const ConditionsHubPage = () => {
  const trail = [
    { name: 'Home', path: '/' },
    { name: 'Conditions', path: '/conditions' },
  ]

  return (
    <>
      <SEO
        title="Conditions We Treat in Midtown Toronto"
        description="Neck and back pain, TMJ and headaches, running injuries, desk-worker pain, shoulder pain, sciatica, and pregnancy care at Yonge & Eglinton."
        path="/conditions"
        noIndex={!conditionsHubReviewed}
        structuredData={[
          breadcrumbs(trail),
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'Conditions We Treat',
            url: `${SITE_URL}/conditions`,
            hasPart: conditions.map((c) => ({
              '@type': 'MedicalWebPage',
              name: c.h1,
              url: `${SITE_URL}/conditions/${c.slug}`,
            })),
          },
        ]}
      />

      <div className="bg-cream-200">
        <PageHero title="Conditions We Treat" subtitle="Find the right care" texture="terracotta-sand" size="sm">
          <p className="font-sans text-dark-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            Care is tailored to your body and goals. Explore the concerns we see most often at our
            Yonge &amp; Eglinton clinic, and how massage therapy, athletic therapy, acupuncture, and
            naturopathic medicine can help.
          </p>
        </PageHero>
      </div>

      <div className="bg-cream-200">
        <Breadcrumbs items={trail} />
      </div>
      <LinkCards
        bg="bg-cream-200"
        heading="Common concerns"
        items={conditions.map((c) => ({
          to: `/conditions/${c.slug}`,
          name: c.name,
          description: c.intro,
          image: c.image,
          imageAlt: c.imageAlt,
        }))}
      />
      <BookingBand />
    </>
  )
}

export default ConditionsHubPage
